import { Injectable } from '@angular/core';
import * as QRCode from 'qrcode';

@Injectable({
  providedIn: 'root'
})
export class QrCodeService {
  constructor() { }

  public async gerarQrCodeAsync(text: string): Promise<string> {
    try {
      return await QRCode.toDataURL(text);;
    } catch (error) {
      console.error('Erro ao gerar QR Code:', error);
      return '';
    }
  }
}
